webpackJsonp([1,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(31);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueResource = __webpack_require__(30);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _App = __webpack_require__(17);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueResource2.default);
	
	new _vue2.default({
	  el: '#app',
	  template: '<App/>',
	  components: { App: _App2.default }
	});

/***/ },
/* 1 */,
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(16)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(5),
	  /* template */
	  __webpack_require__(29),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 3 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'auth',
	
	  stopCallingRefreshAuto: function stopCallingRefreshAuto(idInterval) {
	    clearInterval(idInterval);
	  }
	};

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Grid = __webpack_require__(20);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _Info = __webpack_require__(21);
	
	var _Info2 = _interopRequireDefault(_Info);
	
	var _Bouton = __webpack_require__(2);
	
	var _Bouton2 = _interopRequireDefault(_Bouton);
	
	var _Creation = __webpack_require__(19);
	
	var _Creation2 = _interopRequireDefault(_Creation);
	
	var _CommandContainer = __webpack_require__(18);
	
	var _CommandContainer2 = _interopRequireDefault(_CommandContainer);
	
	var _eventManager = __webpack_require__(3);
	
	var _eventManager2 = _interopRequireDefault(_eventManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	  data: function data() {
	    return {
	      width: 1000,
	      height: 500,
	      newWidth: 100,
	      newHeight: 50,
	      cells: 'cells',
	      numberOfAliveCells: 'Non connu',
	      counter: 0,
	      idInterval: 'Refresh Auto Not Started',
	      baseUrl: 'https://glacial-hamlet-53356.herokuapp.com/',
	
	      errorMessage: 'Pas d\'erreurs'
	    };
	  },
	
	  components: {
	    Grid: _Grid2.default,
	    Info: _Info2.default,
	    Bouton: _Bouton2.default,
	    Creation: _Creation2.default,
	    CommandContainer: _CommandContainer2.default
	  },
	  created: function created() {
	    window.addEventListener('keyup', this.checkKey);
	  },
	
	  methods: {
	    checkKey: function checkKey(e) {
	      if (e.key === 'c') {
	        this.newCreate();
	      } else if (e.key === 'Escape' || e.key === 's') {
	        this.stopRefreshAutomatic();
	      } else if (e.key === 'Enter' || e.key === 'a') {
	        this.refreshAutomatic();
	      } else if (e.key === 'ArrowRight' || e.key === 'r') {
	        this.refresh();
	      }
	    },
	    newCreate: function newCreate(dimension) {
	      var _this = this;
	
	      if (dimension.height === '' || dimension.width === '' || dimension.height === '0' || dimension.width === '0') {
	        dimension.height = '50';
	        dimension.width = '100';
	      }
	
	      console.log('création intelligente d une nouvelle grille formattée', dimension);
	      this.$http.get(this.baseUrl + 'newCreate/100/height/' + dimension.height + '/width/' + dimension.width).then(function (response) {
	        _this.cells = response.body;
	        _this.width = _this.cells[_this.cells.length - 1]['x'] * 10;
	        _this.height = _this.cells[_this.cells.length - 1]['y'] * 10;
	        _this.counter = 0;
	        _this.refreshAutomatic();
	      }, function () {
	        _this.stopRefreshAutomatic();
	        _this.errorMessage = 'Le get newCreate/100/height/' + dimension.height + '/width/' + dimension.width + ' est en échec';
	        console.log(_this.errorMessage);
	      });
	    },
	    refresh: function refresh() {
	      var _this2 = this;
	
	      this.counter += 1;
	      this.$http.get(this.baseUrl + 'grids/100').then(function (response) {
	        _this2.cells = response.body;
	        _this2.width = _this2.cells[_this2.cells.length - 1]['x'] * 10;
	        _this2.height = _this2.cells[_this2.cells.length - 1]['y'] * 10;
	        _this2.errorMessage = 'Pas d\'erreurs';
	      }, function () {
	        _this2.stopRefreshAutomatic();
	        _this2.errorMessage = 'La Base semble être KO !';
	        console.log(_this2.errorMessage);
	      });
	      this.$http.get(this.baseUrl + 'grids/100/count/alive').then(function (response) {
	        if (response.body !== '0') {
	          _this2.numberOfAliveCells = response.body;
	        } else {
	          console.log('0 cellules comptées');
	        }
	      }, function () {
	        _this2.stopRefreshAutomatic();
	        _this2.errorMessage = 'La Base semble être KO !';
	        console.log(_this2.errorMessage);
	      });
	    },
	    refreshAutomatic: function refreshAutomatic() {
	      if (this.idInterval === 'Refresh Auto Not Started') {
	        this.idInterval = setInterval(this.refresh, 1000);
	      }
	    },
	    stopRefreshAutomatic: function stopRefreshAutomatic() {
	      _eventManager2.default.stopCallingRefreshAuto(this.idInterval);
	      this.idInterval = 'Refresh Auto Not Started';
	    },
	    updateNewHeight: function updateNewHeight(value) {
	      this.newHeight = value;
	    },
	    updateNewWidth: function updateNewWidth(value) {
	      this.newWidth = value;
	    }
	  }
	};

/***/ },
/* 5 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'bouton',
	  props: ['className', 'text'],
	  methods: {
	    buttonClick: function buttonClick() {
	      this.$emit('click');
	    }
	  }
	};

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Bouton = __webpack_require__(2);
	
	var _Bouton2 = _interopRequireDefault(_Bouton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'commandContainer',
	  methods: {
	    refresh: function refresh() {
	      this.$emit('refresh');
	    },
	    refreshAutomatic: function refreshAutomatic() {
	      this.$emit('refreshAutomatic');
	    },
	    stopRefreshAutomatic: function stopRefreshAutomatic() {
	      this.$emit('stopRefreshAutomatic');
	    }
	  },
	  components: {
	    Bouton: _Bouton2.default
	  }
	};

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Bouton = __webpack_require__(2);
	
	var _Bouton2 = _interopRequireDefault(_Bouton);
	
	var _InputContainer = __webpack_require__(22);
	
	var _InputContainer2 = _interopRequireDefault(_InputContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'creation',
	  data: function data() {
	    return {
	      updatedNewHeight: '',
	      updatedNewWidth: ''
	    };
	  },
	
	  methods: {
	    click: function click() {
	      var dimension = {
	        height: this.updatedNewHeight,
	        width: this.updatedNewWidth
	      };
	      this.$emit('click', dimension);
	    },
	    width: function width(value) {
	      this.updatedNewWidth = value;
	    },
	    height: function height(value) {
	      this.updatedNewHeight = value;
	    }
	  },
	  components: {
	    Bouton: _Bouton2.default,
	    InputContainer: _InputContainer2.default
	  }
	};

/***/ },
/* 8 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'grid',
	  props: ['cells', 'width', 'height'],
	  directives: {
	    insertInCanvas: function insertInCanvas(canvasElement, binding) {
	      var ctx = canvasElement.getContext('2d');
	      var cells = binding.value.cells;
	
	      ctx.clearRect(0, 0, canvasElement.width, canvasElement.height);
	
	      ctx.fillStyle = binding.value.color;
	      for (var i = 0; i < cells.length; i++) {
	        if (cells[i]['state'] === 'alive') {
	          var x = cells[i]['x'];
	          var y = cells[i]['y'];
	          ctx.fillRect(10 * (x - 1), 10 * (y - 1), 10, 10);
	        }
	      }
	    }
	  }
	};

/***/ },
/* 9 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'informations',
	  props: ['counter', 'numberOfAliveCells', 'errorMessage']
	};

/***/ },
/* 10 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'inputContainer',
	  props: ['text', 'placeholder'],
	  methods: {
	    updateValue: function updateValue(value) {
	      var formattedValue = value.trim();
	      if (formattedValue !== value) {
	        this.$refs.input.value = formattedValue;
	      }
	      this.$emit('input', Number(formattedValue));
	    }
	  }
	};

/***/ },
/* 11 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 12 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 13 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 14 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 15 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 16 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(13)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(4),
	  /* template */
	  __webpack_require__(25),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(11)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(6),
	  /* template */
	  __webpack_require__(23),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(15)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(7),
	  /* template */
	  __webpack_require__(28),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(12)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(8),
	  /* template */
	  __webpack_require__(24),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(14)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(9),
	  /* template */
	  __webpack_require__(27),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(10),
	  /* template */
	  __webpack_require__(26),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 23 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "commandContainer"
	    }
	  }, [_c('bouton', {
	    attrs: {
	      "className": "button-refresh",
	      "text": "Refresh"
	    },
	    on: {
	      "click": _vm.refresh
	    }
	  }), _vm._v(" "), _c('bouton', {
	    attrs: {
	      "className": "button-refresh-automatic",
	      "text": "Start Refresh Automatic"
	    },
	    on: {
	      "click": _vm.refreshAutomatic
	    }
	  }), _vm._v(" "), _c('bouton', {
	    attrs: {
	      "className": "button-stop",
	      "text": "Stop refresh Automatic"
	    },
	    on: {
	      "click": _vm.stopRefreshAutomatic
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ },
/* 24 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "grid"
	    }
	  }, [_c('canvas', {
	    directives: [{
	      name: "insert-in-canvas",
	      rawName: "v-insert-in-canvas",
	      value: ({
	        cells: _vm.cells,
	        color: 'white'
	      }),
	      expression: "{ cells: cells, color: 'white' }"
	    }],
	    staticStyle: {
	      "border": "1px solid #BBB"
	    },
	    attrs: {
	      "width": _vm.width,
	      "height": _vm.height
	    }
	  })])
	},staticRenderFns: []}

/***/ },
/* 25 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('div', {
	    attrs: {
	      "id": "bandeau"
	    }
	  }, [_c('info', {
	    attrs: {
	      "counter": _vm.counter,
	      "numberOfAliveCells": _vm.numberOfAliveCells,
	      "errorMessage": _vm.errorMessage
	    }
	  }), _vm._v(" "), _c('creation', {
	    on: {
	      "click": _vm.newCreate
	    }
	  }), _vm._v(" "), _c('command-container', {
	    on: {
	      "refresh": _vm.refresh,
	      "refreshAutomatic": _vm.refreshAutomatic,
	      "stopRefreshAutomatic": _vm.stopRefreshAutomatic
	    }
	  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('grid', {
	    attrs: {
	      "cells": _vm.cells,
	      "width": _vm.width,
	      "height": _vm.height
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ },
/* 26 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "inputContainer"
	  }, [_c('p', [_vm._v(_vm._s(_vm.text) + " de la nouvelle grille à créer :\n        "), _c('input', {
	    ref: "input",
	    attrs: {
	      "placeholder": _vm.placeholder
	    },
	    domProps: {
	      "value": _vm.model
	    },
	    on: {
	      "input": function($event) {
	        _vm.updateValue($event.target.value)
	      }
	    }
	  })])])
	},staticRenderFns: []}

/***/ },
/* 27 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "informations"
	    }
	  }, [_c('p', {
	    staticClass: "turnMessage"
	  }, [_vm._v("La vie a évolué " + _vm._s(_vm.counter) + " fois.")]), _vm._v(" "), _c('p', {
	    staticClass: "aliveMessage"
	  }, [_vm._v("Nombre de cellules en vie : " + _vm._s(_vm.numberOfAliveCells))]), _vm._v(" "), _c('p', {
	    staticClass: "errorMessage"
	  }, [_vm._v(_vm._s(_vm.errorMessage))])])
	},staticRenderFns: []}

/***/ },
/* 28 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "creation"
	    }
	  }, [_c('input-container', {
	    attrs: {
	      "text": "Hauteur",
	      "value": "updatedNewHeight",
	      "placeholder": "insert a height"
	    },
	    on: {
	      "input": _vm.height
	    }
	  }), _vm._v(" "), _c('input-container', {
	    attrs: {
	      "text": "Largeur",
	      "value": "updatedNewWidth",
	      "placeholder": "insert a width"
	    },
	    on: {
	      "input": _vm.width
	    }
	  }), _vm._v(" "), _c('bouton', {
	    attrs: {
	      "className": "button-create",
	      "text": "Create grid"
	    },
	    on: {
	      "click": _vm.click
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ },
/* 29 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "button"
	  }, [_c('button', {
	    class: _vm.className,
	    on: {
	      "click": _vm.buttonClick
	    }
	  }, [_vm._v(_vm._s(_vm.text))])])
	},staticRenderFns: []}

/***/ },
/* 30 */,
/* 31 */,
/* 32 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ }
]);


// WEBPACK FOOTER //
// static/js/app.18459ebb18e600f1f8cd.js